import { LumoraClient, LUMORA_PROD_API_BASE_URL } from "@lumora/bridge";

export const SITE = import.meta.env.VITE_LUMORA_SITE ?? "alamir-auto";

export const client = new LumoraClient({
  baseUrl: import.meta.env.VITE_LUMORA_API ?? LUMORA_PROD_API_BASE_URL,
});
